import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  initialize() {
    const openEvent = new CustomEvent("open", {});
    const closeEvent = new CustomEvent("close", {});

    $(this.element).on("opening", this.dispatchEvent.bind(this, openEvent));
    $(this.element).on("closed", this.dispatchEvent.bind(this, closeEvent));
  }

  disconnect() {
    $(this.element).off("opening", this.dispatchEvent);
    $(this.element).off("closed", this.dispatchEvent);
  }

  dispatchEvent(customEvent) {
    this.element.dispatchEvent(customEvent);
  }
}
